import { Link, Text } from '@loomhq/lens';
import React from 'react';

import { PRIVACY_POLICY, TERMS } from 'constants/routes';

export default function LegalAgreement({ size }) {
  return (
    <Text htmlTag="p" color="bodyDimmed" size={size}>
      By signing up, I agree to Loom’s{' '}
      <Link
        href={TERMS}
        target="_blank"
        rel="noopener noreferrer"
        variant="neutral"
      >
        Terms
      </Link>{' '}
      and{' '}
      <Link
        href={PRIVACY_POLICY}
        target="_blank"
        rel="noopener noreferrer"
        variant="neutral"
      >
        Privacy Policy
      </Link>
      .
    </Text>
  );
}
